/**
 * View model constructor for social login
 */
app.registerConstructor("SocialLoginCommon", function () {
    const self = this;

    this.remoteLoginFunction = _.noop;

    /**
     * A generic entrance point for remote login. Developer should assign actual specific login logic to self.remoteLoginFunction on different environment.
     * @param token
     * @param id
     * @param fname
     * @param lname
     * @param email
     * @param source
     * @param link
     * @param profile
     * @param profilePicture
     * @returns {*}
     */
    this.doRemoteLogin = function (token, id, fname, lname, email, source, link, profile, profilePicture) {
        return self.remoteLoginFunction(token, id, fname, lname, email, source, link, profile, profilePicture);
    };

    this.redirectPost = function(location, args) {
      var form = '';
      app.console.log(args);
      $.each( args, function( key, value ) {
         form += '<input type="hidden" name="'+key+'" value="'+value+'"/>';
      });
      app.console.log(form);
       $('<form action="' + location + '" method="POST">' + form + '</form>').appendTo($(document.body)).submit();
    }
}).createVM();
